"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.width500 = exports.width400 = exports.width0 = exports.radiusRound = exports.radius900 = exports.radius550 = exports.radius500 = exports.radius450 = exports.radius400 = exports.radius350 = exports.radius300 = exports.radius200 = void 0;
const radius200 = exports.radius200 = "5px";
const radius300 = exports.radius300 = "10px";
const radius350 = exports.radius350 = "15px";
const radius400 = exports.radius400 = "20px";
const radius450 = exports.radius450 = "25px";
const radius500 = exports.radius500 = "30px";
const radius550 = exports.radius550 = "35px";
const radius900 = exports.radius900 = "999999px";
const radiusRound = exports.radiusRound = "999999px";
const width0 = exports.width0 = "0px";
const width400 = exports.width400 = "1px";
const width500 = exports.width500 = "2px";